import * as types from "./types";

const setLoading = loading => ({
  type: types.SET_LOADING,
  payload: loading
});
const createPrePayment = amount => ({
  type: types.CREATE_PRE_PAYMENT,
  payload: amount
});
const createPrePaymentSuccess = invoice => ({
  type: types.CREATE_PRE_PAYMENT_SUCCESS,
  payload: invoice
});

export { setLoading, createPrePayment, createPrePaymentSuccess };
